// Objetivo principal. Os `value` são os MESMOS de sempre — é o que a Cloud
// Function lê para escolher déficit/superávit. Só os rótulos e a casca são
// do redesign.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "ganho muscular", label: "Ganhar massa muscular" },
  { value: "emagrecer", label: "Emagrecer" },
  { value: "ganho peso", label: "Ganhar peso" },
  { value: "controle peso", label: "Manter o peso" },
  { value: "alimentacao saudavel", label: "Comer melhor" },
  { value: "controle doenca", label: "Controlar uma condição de saúde" },
];

const StepQuestionObjective = ({ setCanProceed, setStepData }) => {
  const [objetivo, setObjetivo] = useState("");

  useEffect(() => {
    const valido = Boolean(objetivo);
    setCanProceed(valido);
    setStepData(valido ? { QUESTION_OBJECTIVE: objetivo } : null);
  }, [objetivo, setCanProceed, setStepData]);

  return <Opcoes opcoes={OPCOES} valor={objetivo} onSelecionar={setObjetivo} nome="Objetivo" />;
};

export default StepQuestionObjective;
